import React from "react";
import { TableHead, TableRow, TableCell, IconButton } from "@mui/material";
import AddNewIcon from "../../Images/AddNew.png";
import { TABLE_STYLES } from "./wageTableUtils";

/**
 * Table header for the Wage Mapping table.
 * Renders column labels and the Add Row button.
 */
const WageMappingTableHead = React.memo(function WageMappingTableHead({ showItemColumn, isReadOnly, isHoursDecimal, onAddRow }) {
    return (
        <TableHead sx={TABLE_STYLES.tableHead}>
            <TableRow sx={{ backgroundColor: "#f2f2f2" }}>
                {showItemColumn && (
                    <TableCell sx={{ backgroundColor: "#f6e0c2", color: "#b8741a !important" }}>
                        Wage
                    </TableCell>
                )}
                <TableCell sx={{ backgroundColor: "#f6e0c2", color: "#b8741a !important" }}>
                    {showItemColumn ? "Mapped to" : "Wage"}
                </TableCell>
                <TableCell>COA</TableCell>
                <TableCell>Hrs</TableCell>
                <TableCell>Rate</TableCell>
                <TableCell>Gross Pay</TableCell>
                <TableCell align="center">
                    <IconButton
                        size="small"
                        disabled={isReadOnly}
                        onClick={onAddRow}
                    >
                        <img src={AddNewIcon} alt="Add new" height={20} width={20} />
                    </IconButton>
                </TableCell>
            </TableRow>
        </TableHead>
    );
});

export default WageMappingTableHead;
